var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['wrapBg',_vm.bgImg]},[_c('div',{staticClass:"wrapTitle text-center",style:({color:_vm.color})},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"wrapBox"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }